(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .controller('TrProjectDeleteController',TrProjectDeleteController);

    TrProjectDeleteController.$inject = ['$uibModalInstance', 'entity', 'TrProject','$scope'];

    function TrProjectDeleteController($uibModalInstance, entity, TrProject,$scope) {
        var vm = this;

        vm.trProject = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;
        
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
        	$scope.deletefail = true;
            TrProject.delete({id: id},
                function () {
            	
            	 $scope.deletefail = false;
                    $uibModalInstance.close(true);
                });
           
        }
    }
})();
